<template>
  <div id="app">
    <router-view />
    <!-- <CookieConsent v-if="!this.$appName" /> -->
    <div class="hide-cadeaubon" @click="stopEvent">
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    stopEvent(event) {
      event.stopPropagation();
      event.preventDefault();
    }
  }
};
</script>

<style>
html {
  scroll-behavior: smooth;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* .hide-cadeaubon should always be on top of the iframe, be 100px wide and 100px high and be red
*/

.hide-cadeaubon {
  z-index: 2147483647; /* Max z-index value */
  color: rgba(168,160,89,1) ;
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 124px;
  height: 32px;
  background-color: rgba(168,160,89,1);
  /* pointer-events: none; Removed to allow click capture */
}
</style>
